module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAlCAYAAAAuqZsAAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfUlEQVRYhe3YIQqAYBBE4flFsCh4FME7eSjPIuiNLGITZQWTadqG98qGLV+eMrXqJQ1K1HxoqwNVF61dVVLI9uuOUwKmQI1NDthyvjBVv0+SgLkBcwPmBswNmBswN2BuwNyAuQFzA+YGzA2YGzA3YG7A3N5FMebFb8lLkaQHufcP2IBHE3AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-red-2.png
// module id = 259
// module chunks = 0